<template>
     <b-form>
        <b-form-group :label="$lang('atype')">        
          <b-form-select required v-model="item.vacationtype" :options='absenceTypes'></b-form-select>
        </b-form-group>
        <b-form-group v-if="showSpecialTypes" :label="$lang('aspecialtype')">        
          <b-form-select v-model="item.specialtype" :options='specialTypesArr'></b-form-select>
        </b-form-group>
        <b-form-checkbox class="mb-2" v-if="showSpecialTypes" v-model="item.specialShort">{{$lang('aSpecialShort')}}</b-form-checkbox>
        <b-form-group :label="$lang('date')">        
          <b-form-input required v-model="item.dbeg" type='date' ></b-form-input>
          <b-form-invalid-feedback>{{$lang('errdate')}}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="$lang('todate')" v-show="showUntilDate">        
          <b-form-input v-model="item.dend" type='date' ></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang('ptype')" v-show="showPeriodType" v-if="!isSeekLeave">        
          <b-form-select v-model="item.periodtype" :options='periodTypes'></b-form-select>
        </b-form-group>
        <b-form-group :label="$lang('sabegin')" v-if="showShortAbsence">        
          <b-form-input v-model="item.shortstart" :required="shortAbsenceRequired" type='time' ></b-form-input>
          <b-form-invalid-feedback>{{$lang('errtime')}}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="$lang('saduration')" v-if="showShortAbsence">        
          <b-form-select v-model="item.shortduration" :required="shortAbsenceRequired" :options='shortDurations'></b-form-select>
          <b-form-invalid-feedback>{{$lang('errsaduration')}}</b-form-invalid-feedback>
        </b-form-group>
        <div v-if="canEmCase">
          <b-form-checkbox class="mb-2" v-model="item.emcaseconfirm">{{$lang('emcaseConfirmation')}}</b-form-checkbox>
          <div class="emcaselbl">{{$lang('emcaseLabel')}}</div>
          <div v-if="item.emcaseconfirm">
            <b-form-group :label="$lang('emcase')" v-if="canEmCase">        
              <b-form-select v-model="item.emcase" :options='emCases'></b-form-select>
            </b-form-group>
            <b-form-group :label="$lang('emcaseOther')" v-if="emCaseOther">        
              <b-form-input v-model="item.emcaseother" type='text' required=true></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-form-group :label="$lang('remark')">
          <b-form-textarea v-model="item.remark"></b-form-textarea>
        </b-form-group>  
        <b-form-group :label="$lang('file')" v-if="isShowAttach">
          <img class="filepreview" v-if="item.imagedata" :src="item.imagedata">
          <b-form-file v-if="!item.imagedata" accept="image/jpeg, image/png" @input="addFile" ref="file-input" :browse-text='$lang("browse")'></b-form-file>
        </b-form-group>  
        <b-button v-if="item.imagedata && isShowAttach" @click.prevent='removeFile'>
          <i class="fa fa-trash-o"></i>
        </b-button> 
        <b-alert v-if="item.error" show variant="danger">{{item.error}}</b-alert>
        <div v-if="item.wait" class="d-flex mt-1">
           <b-spinner variant="primary"></b-spinner>
           <span class="ml-3 mt-1">{{$lang('saving')}}</span>
        </div>
     </b-form>
</template>

<script>
  import axios from "axios";
   export default {
    created() {
      this.loadSpecialTypes();
    },
    props: ['item'],
    methods: {
      async readFile(file) {
        let result_base64 = await new Promise((resolve) => {
          let fr = new FileReader();
          fr.onload = (e) => resolve(fr.result);
          fr.readAsDataURL(file);
        });
        return result_base64;
      },    
      async addFile(i){
        if (i) {
          if (i.size > 1024*1024*5){
            this.$bvToast.toast("File size is too big: "+i.name+" Maximum file size: 5MB", {title: "Error", variant: "danger"});
          } else {
            this.item.imagedata = await this.readFile(i);
          }
          this.$refs['file-input'].reset();
        }
      },
      async removeFile(){
        this.item.imagedata = null;
      },
      loadSpecialTypes() {
        axios
        .get("/api/GetSpecialLeaves")
        .then(resp => {
          this.specialTypes = resp.data;
          this.specialTypesArr = []
          if (Array.isArray(resp.data.specialleavesarr)){
            resp.data.specialleavesarr.forEach((i)=>{
              this.specialTypesArr.push({value:i.id,text:i.name})
            })
          }
        })

      }
     },
     data() {
       return {
          absenceTypes: [
            {value: 10, text: this.$lang('vt_vacation')},
            {value: 15, text: this.$lang('vt_unpaid')},
            {value: 20, text: this.$lang('vt_seak')},
            {value: 30, text: this.$lang('vt_short')},
            {value: 50,	text: this.$lang('vt_business')},
            {value: 60,	text: this.$lang('vt_training')},
            {value: 70,	text: this.$lang('vt_special')},
            {value: 100,	text: this.$lang('vt_childcare')},
          ] ,
          periodTypes: [
            {value: 1, text: this.$lang('pt_full')},
            {value: 2, text: this.$lang('pt_forenoon')},
            {value: 3, text: this.$lang('pt_afternoon')},
          ],
          shortDurations: [
            {value: 15, text: "15 minutes"},
            {value: 30, text: "30 minutes"},
            {value: 45, text: "45 minutes"},
            {value: 60, text: "1 hour"},
            {value: 75, text: "1 hour 15 minutes"},
            {value: 90, text: "1 hour 30 minutes"},
            {value: 105, text: "1 hour 45 minutes"},
            {value: 120, text: "2 hours"},
            {value: 135, text: "2 hours 15 minutes"},
            {value: 150, text: "2 hours 30 minutes"},
            {value: 165, text: "2 hours 45 minutes"},
            {value: 180, text: "3 hours"},
            {value: 195, text: "3 hours 15 minutes"},
            {value: 210, text: "3 hours 30 minutes"},
          ],
          emCases: [
            {value:0, text:""},
            {value:1, text:this.$lang('ec_transport')},
            {value:2, text:this.$lang('ec_delay')},
            {value:3, text:this.$lang('ec_weather')},
            {value:4, text:this.$lang('ec_private')},
            {value:99, text:this.$lang('ec_other')},
          ],
          specialTypes: {},
          specialTypesArr: [],
       }
     },
     computed: {
        showUntilDate: function() {
          if (this.showSpecialTypes){
            return !this.item.specialShort
          }
          return this.item.vacationtype != 30;
        },
        showPeriodType: function() {
          if (this.showSpecialTypes){
            return !this.item.specialShort
          }
          return !this.item.dend && this.item.vacationtype != 30;
        },
        showShortAbsence: function() {
          if (this.showSpecialTypes){
            return this.item.specialShort
          }
          return this.item.vacationtype === 30;
        },
        canEmCase: function(){
          return [30, 10, 15, 70].includes(this.item.vacationtype);
        },
        emCaseOther: function(){
          return this.item.emcase == 99;
        },
        emCaseNeedConfirm: function(){
          return this.item.emcase > 0;
        },
        shortAbsenceRequired: function() {
          if (this.item.vacationtype === 30)
             return "required";
          return null   
        },
        isSeekLeave: function() {
          return this.item.vacationtype === 20;
        },
        isShowAttach: function() {
          return this.item.vacationtype === 20 || this.item.vacationtype === 100;
        },
        showSpecialTypes: function() {
          return this.item.vacationtype === 70 && this.specialTypes && this.specialTypes.specialleaves === 1
        }
     },
  locales: {
    en: {
        atype: "Absence Type:",
        date: "Date:",
        todate: "Until Date:",
        ptype: "Period Type:",
        sabegin: "Short Absence Begin:",
        saduration: "Short Absence Duration:",
        remark: "Remark:",
        file: "Sickness Notification:",
        saving: "Saving document, please wait...",
        errsaduration: "Please enter duration",
        errtime: "Please enter valid time",
        errdate: "Please enter valid date",
        pt_full: "Full",
        pt_forenoon: "Forenoon",
        pt_afternoon: "Afternoon",
        vt_vacation: "Vacation",
        vt_unpaid: "Unpaid Leave",
        vt_seak: "Sick Leave",
        vt_short: "Short Absence",
        vt_business: "Business Trip",
        vt_training: "Training",
        vt_special: "Special Leave",
        vt_childcare: "Child Care",
        browse: "Browse",
        emcase: "Emergency Case",
        emcaseOther: "Other Reason",
        ec_transport: "Defect Transport",
        ec_delay: "Delay",
        ec_weather: "Weather/Road Conditions",
        ec_private: "Emergency in Private Area",
        ec_other: "Other reason",
        emcaseConfirmation: "By submitting this application, I confirm that the information provided on the emergency category is correct and I agree to a system-supported evaluation by the employer",
        emcaseLabel: "This field may be filled out only in exceptional cases, for example, when a time off is urgently required and there is no opportunity to agree it with your supervisor due to short notice.",
        aspecialtype: "Special Leave Type",
        aSpecialShort: "Short Special Leave",
      },
    de: {
        atype: "Abwesenheitsart:",
        date: "Datum Beginn:",
        todate: "Datum Ende:",
        ptype: "Periodentyp:",
        sabegin: "Kurze Abwesenheit ab:",
        saduration: "Kurze Abwesenheitsdauer:",
        remark: "Bemerkung:",
        file: "Arbeitsunfähigkeitsbescheinigung:",
        saving: "Dokument wird gespeichert, bitte warten ...",
        errsaduration: "Bitte geben Sie die Dauer ein",
        errtime: "Bitte gültige Zeit eingeben",
        errdate: "Bitte geben Sie ein gültiges Datum ein",
        pt_full: "Ganztag",
        pt_forenoon: "Vormittag",
        pt_afternoon: "Nachmittag",
        vt_vacation: "Urlaub",
        vt_unpaid: "Unbezahlter Urlaub",
        vt_seak: "Krankmeldung",
        vt_short: "Kurzfristige Abwesenheit",
        vt_business: "Dienstreise",
        vt_training: "Fortbildung",
        vt_special: "Sonderurlaub",
        vt_childcare: "Kinderbetreuung",
        browse: "Durchsuchen",
        emcase: "Notfall",
        emcaseOther: "Sonstige",
        ec_transport: "Defektes Transportmittel",
        ec_delay: "Verspätung",
        ec_weather: "Wetter-/Strassenverhältnisse",
        ec_private: "Notfall im privaten Bereich",
        ec_other: "Sonstige",
        emcaseConfirmation: "Mit Antragstellung versichere ich, dass die gemachten Angaben zur Notfallkategorie zutreffend sind und stimme einer systemunterstützen Auswertung durch den Arbeitgeber zu",        
        emcaseLabel: "Dieses Feld darf nur in Ausnahmefällen ausgefüllt werden, z. B. wenn eine Freistellung dringend erforderlich ist und aufgrund des kurzfristigen Eintretens nicht mit Ihrem Vorgesetzten abgestimmt werden kann.",
        aspecialtype: "Art des Sonderurlaubs",
        aSpecialShort: "Kurzer Sonderurlaub",
    },
    ru: {
        atype: "Вид отсутствия:",
        date: "Дата:",
        todate: "До даты:",
        ptype: "Период:",
        sabegin: "Короткое отсуствие с:",
        saduration: "Длительность короткого отсутствия:",
        remark: "Примечания:", 
        file: "Больничный лист:",
        saving: "Сохранение документа, пожалуйста подождите...",
        errsaduration: "Введите длительность короткого отсутствия",
        errtime: "Введите корректное время",
        errdate: "Введите корректную дату",
        pt_full: "Весь рабочий день",
        pt_forenoon: "До полудня",
        pt_afternoon: "После полудня",
        vt_vacation: "Отпуск",
        vt_unpaid: "Неоплачиваемый отпуск",
        vt_seak: "Больничный",
        vt_short: "Кратковременное отсутствие",
        vt_business: "Business Trip",
        vt_training: "Обучение",
        vt_special: "Special Leave",
        vt_childcare: "Уход за ребенком",
        browse: "Выбрать",
        emcase: "Непредвиденные обстоятельства",
        emcaseOther: "Другая причина",
        ec_transport: "Поломка транспортного средства",
        ec_delay: "Опоздание",
        ec_weather: "Условия погоды/дороги",
        ec_private: "Непредвиденные личные обстоятельства",
        ec_other: "Другая причина",
        emcaseConfirmation: "Подавая это заявление, я подтверждаю, что вся указанная информация является достоверной и правильной. Я согласен, что работодатель оценит ситуацию согласно предоставленной информации",
        emcaseLabel: "Это поле разрешено заполнять только в исключительных случаях, например, когда очень срочно нужен отгул и нет возможности согласовать его с начальником.",
        aspecialtype: "Тип специального отпуска",
        aSpecialShort: "Короткий специальный отпуск",
    },
    pl: {
        atype: "Typ:",
        date: "Data:",
        todate: "Aktualny:",
        ptype: "Okres nieobecności:",
        sabegin: "Godzina rozpoczęcia nieobecności:",
        saduration: "Długość nieobecności:",
        remark: "Uwagi:", 
        file: "Zwolnienie lekarskie:",
        saving: "Zapisywanie dokumentu. Proszę czekać...",
        errsaduration: "Wprowadź czas krótkiej nieobecności",
        errtime: "Wprowadź poprawny czas",
        errdate: "Proszę wprowadź poprawną datę",
        pt_full: "Cały dzień roboczy",
        pt_forenoon: "Przed południem",
        pt_afternoon: "Popołudnie",
        vt_vacation: "Wakacje",
        vt_unpaid: "Urlop bezpłatny",
        vt_seak: "Zwolnienie lekarskie",
        vt_short: "Krótka nieobecność",
        vt_business: "Business Trip",
        vt_training: "Edukacja",
        vt_special: "Special Leave",
        vt_childcare: "Opieka nad dzieckiem",
        browse: "Wybierać",
        emcase: "Niewidziane okoliczności",
        emcaseOther: "Inny powód",
        ec_transport: "Awaria pojazdu",
        ec_delay: "Być spóźnionym",
        ec_weather: "Warunki pogodowe/drogowe",
        ec_private: "Nieprzewidziane okoliczności osobiste",
        ec_other: "Inny powód",
        emcaseConfirmation: "Przesyłając niniejszy wniosek, potwierdzam, że podane informacje dotyczące kategorii awaryjnej są prawidłowe i wyrażam zgodę na systemową ocenę przez pracodawcę",
        emcaseLabel: "Pole to można wypełnić jedynie w wyjątkowych przypadkach, np. gdy pilnie potrzebny jest urlop, a ze względu na krótki termin nie ma możliwości uzgodnienia go z przełożonym.",
        aspecialtype: "Rodzaj urlopu specjalnego",
        aSpecialShort: "Krótki urlop specjalny",
    }    
  }
}
</script>


<style>
  .filepreview {
    max-height: 200px;
    width: 100%;
    object-fit: contain;
  }
  .emcaselbl{
    padding: 4px 0 12px 24px;
  }
</style>


// WEBPACK FOOTER //
// src/AproposalItem.vue